import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";

function modalBackThirdStep ({ show, onHide, onBack }) {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.modalBack
  }));
  return (
    <>
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton className="border-0">
        <Modal.Title>{lang[0]}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        <p className="mb-4">{lang[1]}</p>
      <Row className="gx-2">
        <Col xs={6}>
          <Button variant={"outline-primary"} className="w-100 py-3" onClick={onHide}>
            {lang[2]}
          </Button>
        </Col>
        <Col xs={6}>
          <Button variant={"primary"} className="w-100 py-3 fw-bold" onClick={() => {
            window.location.href = onBack;
          }}>
            {lang[3]}
          </Button>
        </Col>
      </Row>
      </Modal.Body>
    </Modal>
    </>
  );
}


export default modalBackThirdStep;